<template>
  <v-app>
    <v-toolbar color="primary" dark app>
      <!-- <div class="logo scantrust-logo"></div> -->
      <v-toolbar-title>Blockchain Supply Chain Administrator</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
    </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <v-snackbar v-model="snackBar.show" bottom>
      {{ snackBar.message }}
      <v-btn color="primary" flat @click="closeSnackBar()">
        dismiss
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>

import { isLoggedIn } from '@/services/AuthService'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  computed: mapGetters({
    snackBar: 'snackBar'
  }),
  methods: {
    isLoggedIn,

    closeSnackBar () {
      this.$store.dispatch('dissmissSnackBar')
    }
  },
}
</script>

<style lang="scss">

html {
  height: 100%;
  width: 100%;
}

body {
  height: 100%;
  width: 100%;
  margin: 0;
  margin-left: auto;
  margin-right: auto;
  background: white;
}

.v-content{
  background: white;
}

#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.logo {
  width: 150px;
  height: 100px;
}

.scantrust-logo {
  width: 28px;
  height: 28px;
  background: url('./assets/logo.png') no-repeat;
}

</style>
